import React, { useState, useEffect, useRef, useCallback } from 'react';
import { View, Text, TextInput, StyleSheet, Icon, Icon2, Icon3 } from '../lib/react-native-compat';
import { loadUserData, updateUserDataArray, f, fNum, pNum } from '../db/company';
import { currentUserIdAtom, selectedJobAtom, currentUserNameAtom, selectedVersionAtom, jobUserDataAtom, isLiveVersionAtom, userNameAtom, userIdAtom } from '../store/company';
import { useAtom } from 'jotai';
import { NumberInput } from './numberInput';
import { max } from 'moment';

const Contingency = () => {
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [userData, setUserData] = useAtom(jobUserDataAtom);
    const [currentUserId, setSelectedUser] = useAtom(currentUserIdAtom);
    const [currentUserName, setCurrentUserName] = useAtom(currentUserNameAtom);
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [userName] = useAtom(userNameAtom);
    const [userId] = useAtom(userIdAtom);
    const [totalOriginal, setTotalOriginal] = useState('-');
    const [totalOriginalLabor, setTotalOriginalLabor] = useState('-');
    const [totalOriginalEquipment, setTotalOriginalEquipment] = useState('-');
    const [totalOriginalMaterials, setTotalOriginalMaterials] = useState('-');
    const [totalOriginalSubs, setTotalOriginalSubs] = useState('-');
    const [totalOriginalOther, setTotalOriginalOther] = useState('-');
    const [totalCurrent, setTotalCurrent] = useState('-');
    const [totalCurrentLabor, setTotalCurrentLabor] = useState('-');
    const [totalCurrentEquipment, setTotalCurrentEquipment] = useState('-');
    const [totalCurrentMaterials, setTotalCurrentMaterials] = useState('-');
    const [totalCurrentSubs, setTotalCurrentSubs] = useState('-');
    const [totalCurrentOther, setTotalCurrentOther] = useState('-');
    const [contingencyRows, setContingencyRows] = useState([]);
    const [riskExpanded, setRiskExpanded] = useState(false)
    const [originalAmountOpen, setOriginalAmountOpen] = useState(false)
    const [currentAmountOpen, setCurrentAmountOpen] = useState(true)

    useEffect(() => {
        if (selectedJob && selectedVersion) {
            loadUserData({ id: selectedJob, forecastGuid: selectedVersion, live: isLiveVersion }).then((data) => {
                //console.log('user data', data?.data)
                setUserData(data?.data);
            })
        }
    }, [selectedJob, selectedVersion])

    const setupRows = (data) => {
        const cData = {}
        if (data && data.length > 0) {
            data.forEach((item) => {
                if (item.Forecast_Tab == 'Contingency') {
                    //console.log('item', item)
                    if (cData[item?.Forecast_Row_ID]) {
                        cData[item?.Forecast_Row_ID][item.Forecast_Field_Name] = item.Forecast_Value
                    } else {
                        cData[item?.Forecast_Row_ID] = {
                            id: item?.Forecast_Row_ID,
                            [item.Forecast_Field_Name]: item.Forecast_Value
                        }
                    }
                }
            })
        }
        //console.log('cData', cData)
        calculateTotals(Object.values(cData))
    }

    const calculateTotals = (rows) => {
        let currentLabor = 0
        let currentEquipment = 0
        let currentMaterials = 0
        let currentSubs = 0
        let currentOther = 0
        let originalLabor = 0
        let originalEquipment = 0
        let originalMaterials = 0
        let originalSubs = 0
        let originalOther = 0
        rows.forEach((item) => {
            currentLabor += pNum(item.CurrentLabor)
            currentEquipment += pNum(item.CurrentEquipment)
            currentMaterials += pNum(item.CurrentMaterials)
            currentSubs += pNum(item.CurrentSubs)
            currentOther += pNum(item.CurrentOther)
            originalLabor += pNum(item.OriginalLabor)
            originalEquipment += pNum(item.OriginalEquipment)
            originalMaterials += pNum(item.OriginalMaterials)
            originalSubs += pNum(item.OriginalSubs)
            originalOther += pNum(item.OriginalOther)
        })

        const statusOptions = [
            '3rd Party Price Volatility',
            'Weather',
            'Warranty / Duration',
            'Terrain',
            'Sub Surface Conditions',
            'Staffing',
            'Security Risk',
            'Scope',
            'Schedule',
            'Safety - HSE',
            'Quality Risk',
            'Other Unidentified Risk',
            'Liquidated Damages',
            'Contract',
            'Client'
        ]

        const cO = {
            '3rd Party Price Volatility': 1,
            'Weather': 2,
            'Warranty / Duration': 3,
            'Terrain': 4,
            'Sub Surface Conditions': 5,
            'Staffing': 6,
            'Security Risk': 7,
            'Scope': 8,
            'Schedule': 9,
            'Safety - HSE': 10,
            'Quality Risk': 11,
            'Other Unidentified Risk': 12,
            'Liquidated Damages': 13,
            'Contract': 14,
            'Client': 15
        }

        //standardRows.forEach((item) => {
        let found = false
        // rows.forEach((row) => {
        //     if (row.Risk_Description === item) {
        //         found = true
        //     }
        // })
        // if (!found) {
        // rows.push({
        //     Item: '',
        //     Status: '',
        //     Risk_Description: '',
        //     Potential_Impact: '',
        //     Handling_Strategies: '',
        //     Action_Owner: '',
        //     Probability_Assessment: '',
        //     Severity: '',
        //     Risk_Rating: '',
        //     Risk_Category: '',
        //     Probability_Assessment_Current: '',
        //     Severity_Current: '',
        //     Risk_Rating_Current: '',
        //     Risk_Category_Current: '',
        //     Original_Labor: '',
        //     Original_Equipment: '',
        //     Original_Materials: '',
        //     Original_Subs: '',
        //     Original_Other: '',
        //     Date_Identified: '',
        //     Date_Expected: '',
        //     Date_Closed: '',
        //     Current_Amount: '',
        //     Current_Labor: '',
        //     Current_Equipment: '',
        //     Current_Materials: '',
        //     Current_Subs: '',
        //     Current_Other: ''
        // })
        //}
        //})


        setTotalCurrentLabor(fNum(currentLabor))
        setTotalCurrentEquipment(fNum(currentEquipment))
        setTotalCurrentMaterials(fNum(currentMaterials))
        setTotalCurrentSubs(fNum(currentSubs))
        setTotalCurrentOther(fNum(currentOther))
        setTotalCurrent(fNum(currentLabor + currentEquipment + currentMaterials + currentSubs + currentOther))

        setTotalOriginalLabor(fNum(originalLabor))
        setTotalOriginalEquipment(fNum(originalEquipment))
        setTotalOriginalMaterials(fNum(originalMaterials))
        setTotalOriginalSubs(fNum(originalSubs))
        setTotalOriginalOther(fNum(originalOther))
        setTotalOriginal(fNum(originalLabor + originalEquipment + originalMaterials + originalSubs + originalOther))

        rows.sort((a, b) => {
            // Sort by Item # first if it exists
            const aItem = a.Item ? parseFloat(a.Item) || a.Item : null;
            const bItem = b.Item ? parseFloat(b.Item) || b.Item : null;
            
            if (aItem !== null && bItem !== null) {
                if (typeof aItem === 'number' && typeof bItem === 'number') {
                    return aItem - bItem;
                }
                return String(aItem).localeCompare(String(bItem));
            }
            if (aItem !== null) return -1;
            if (bItem !== null) return 1;
            
            // Then sort by createdAt date
            if (a.createdAt && b.createdAt) {
                return new Date(a.createdAt) - new Date(b.createdAt);
            }
            return 0;
        });
        setContingencyRows(rows)
    }

    useEffect(() => {
        setupRows(userData)
    }, [userData])


    const s = (w = null) =>
        StyleSheet.create({
            spanT: {
                width: w ? w : 100,
                maxWidth: w ? w : 100,
                alignItems: 'center',
                fontSize: 13,
                padding: 10,
                textAlign: 'right',
                justifyContent: 'flex-end',
                borderBottomWidth: 1,
                borderBottomColor: '#e2e8f0',
            },
            spanTB: {
                width: w ? w : 100,
                maxWidth: w ? w : 100,
                alignItems: 'center',
                fontSize: 13,
                padding: 10,
                textAlign: 'right',
                justifyContent: 'flex-end',
                borderBottomWidth: 1,
                borderBottomColor: '#e2e8f0',
                backgroundColor: '#f8fafc',
                fontWeight: '600',
            },
            spanTR: {
                width: w ? w : 100,
                maxWidth: w ? w : 100,
                alignItems: 'center',
                fontSize: 13,
                padding: 10,
                textAlign: 'right',
                justifyContent: 'flex-end',
                borderBottomWidth: 1,
                borderBottomColor: '#e2e8f0',
            },
            spanH: {
                width: w ? w : 100,
                maxWidth: w ? w : 100,
                alignItems: 'center',
                fontSize: 13,
                fontWeight: '600',
                padding: 12,
                textAlign: 'center',
                borderBottomWidth: 2,
                borderBottomColor: '#2563eb',
                backgroundColor: '#f8fafc',
                color: '#1e293b',
            },
            spanHR: {
                width: w ? w : 100,
                maxWidth: w ? w : 100,
                alignItems: 'center',
                fontSize: 13,
                fontWeight: '600',
                padding: 12,
                textAlign: 'center',
                borderBottomWidth: 2,
                borderBottomColor: '#2563eb',
                backgroundColor: '#f8fafc',
                color: '#1e293b',
            },
            dropdown: {
                height: 40,
                width: w ? w : 100,
                maxWidth: w ? w : 100,
                borderColor: 'white',
                paddingHorizontal: 8,
                borderColor: '#aeadaf',
                borderWidth: 1,
            },
        });

    const Row = ({ id, data }) => {
        const [item, setItem] = useState(data?.Item ? data?.Item : '');
        const [status, setStatus] = useState(data?.Status ? data?.Status : '');
        const [riskDescription, setRiskDescription] = useState(data?.Risk_Description ? data?.Risk_Description : '');
        const [potentialImpact, setPotentialImpact] = useState(data?.Potential_Impact ? data?.Potential_Impact : '');
        const [handlingStrategies, setHandlingStrategies] = useState(data?.Handling_Strategies ? data?.Handling_Strategies : '');
        const [actionOwner, setActionOwner] = useState(data?.Action_Owner ? data?.Action_Owner : '');
        const [probabilityAssessment, setProbabilityAssessment] = useState(data?.Probability_Assessment ? data?.Probability_Assessment : '');
        const [severity, setSeverity] = useState(data?.Severity ? data?.Severity : '');
        const [riskRating, setRiskRating] = useState(data?.Risk_Rating ? data?.Risk_Rating : '');
        const [riskCategory, setRiskCategory] = useState(data?.Risk_Category ? data?.Risk_Category : '');
        const [probabilityAssessmentCurrent, setProbabilityAssessmentCurrent] = useState(data?.Probability_Assessment_Current ? data?.Probability_Assessment_Current : '');
        const [severityCurrent, setSeverityCurrent] = useState(data?.Severity_Current ? data?.Severity_Current : '');
        const [riskRatingCurrent, setRiskRatingCurrent] = useState(data?.Risk_Rating_Current ? data?.Risk_Rating_Current : '');
        const [riskCategoryCurrent, setRiskCategoryCurrent] = useState(data?.Risk_Category_Current ? data?.Risk_Category_Current : '');
        const [originalAmount, setOriginalAmount] = useState();
        const [originalLabor, setOriginalLabor] = useState(data?.Original_Labor ? f(data?.Original_Labor) : '');
        const [originalEquipment, setOriginalEquipment] = useState(data?.Original_Equipment ? f(data?.Original_Equipment) : '');
        const [originalMaterials, setOriginalMaterials] = useState(data?.Original_Materials ? f(data?.Original_Materials) : '');
        const [originalSubs, setOriginalSubs] = useState(data?.Original_Subs ? f(data?.Original_Subs) : '');
        const [originalOther, setOriginalOther] = useState(data?.Original_Other ? f(data?.Original_Other) : '');
        const [dateIdentified, setDateIdentified] = useState(data?.Date_Identified ? data?.Date_Identified : '');
        const [dateExpected, setDateExpected] = useState(data?.Date_Expected ? data?.Date_Expected : '');
        const [dateClosed, setDateClosed] = useState(data?.Date_Closed ? data?.Date_Closed : '');
        const [currentAmount, setCurrentAmount] = useState(data?.CurrentAmount ? f(data?.CurrentAmount) : '');
        const [currentLabor, setCurrentLabor] = useState(data?.CurrentLabor ? f(data?.CurrentLabor) : data?.CurrentLabor ? f(data?.CurrentLabor) : '');
        const [currentEquipment, setCurrentEquipment] = useState(data?.CurrentEquipment ? f(data?.CurrentEquipment) : data?.CurrentEquipment ? f(data?.CurrentEquipment) : '');
        const [currentMaterials, setCurrentMaterials] = useState(data?.CurrentMaterials ? f(data?.CurrentMaterials) : data?.CurrentMaterials ? f(data?.CurrentMaterials) : '');
        const [currentSubs, setCurrentSubs] = useState(data?.CurrentSubs ? f(data?.CurrentSubs) : data?.CurrentSubs ? f(data?.CurrentSubs) : '');
        const [currentOther, setCurrentOther] = useState(data?.CurrentOther ? f(data?.CurrentOther) : data?.CurrentOther ? f(data?.CurrentOther) : '');
        const [rowId, setRowId] = useState(id ? id : Math.random().toString(8).slice(2).substring(0, 9))
        const [isFocus, setIsFocus] = useState(false)
        const [value, setValue] = useState('')
        const changeListRef = useRef([]);

        const debounce = (func, delay) => {
            let timeoutId;
            return (...args) => {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(() => {
                    func(...args);
                }, delay);
            };
        }

        const debounceSave = useCallback(
            debounce(() => {
                console.log('here in save', changeListRef.current);
                saveValues(changeListRef.current);
                changeListRef.current = [];
            }, 2000),
            []
        );

        const handleInputChange = (key, value, costType = null) => {
            changeListRef.current.push({ key: key, value: value });
            debounceSave();
        };


        const saveValues = (values) => {
            const uData = JSON.parse(JSON.stringify(contingencyRows))
            if (values.length > 0) {
                const v = values[values.length - 1]
                const value = v.value
                const key = v.key
                const costType = v.costType
                let data = {
                    userId: userId || 'seth.bailey@strikeusa.com',
                    userName: userName || 'Seth Bailey',
                    fieldName: key,
                    tab: "Contingency",
                    rowId: rowId,
                    version: selectedVersion + '',
                    value: value + '',
                    id: selectedJob,
                    costType: costType ? costType + '' : '',
                    costCode: '101101',
                    projectStart: ('Date_Identified', 'Date_Expected', 'Date_Closed').includes(key) ? value : '',
                    valueAmount: ('CurrentLabor', 'CurrentEquipment', 'CurrentMaterials', 'CurrentSubs', 'CurrentOther').includes(key) ? pNum(value) : ''
                }
                console.log('saving data', data)
                updateUserDataArray(data)

                let notFound = true
                uData.forEach((log) => {
                    //console.log('log id', log.id, rowId, fieldName, value)
                    if (log.id === rowId) {
                        notFound = false
                        log[key] = value
                    }
                })

                if (notFound) {
                    const newRow = {
                        id: rowId,
                        [key]: value
                    }
                    uData.push(newRow)
                }
                calculateTotals(uData)
                console.log('updated data', uData)
                setContingencyRows(uData)
            }
        }

        useEffect(() => {
            const oL = pNum(originalLabor?.floatValue)
            const oE = pNum(originalEquipment?.floatValue)
            const oM = pNum(originalMaterials?.floatValue)
            const oS = pNum(originalSubs?.floatValue)
            const oO = pNum(originalOther?.floatValue)
            // console.log('original amount', oL, oE, oM, oS, oO, fNum(oL + oE + oM + oS + oO))
            setOriginalAmount(fNum(oL + oE + oM + oS + oO))
        }, [originalLabor, originalEquipment, originalMaterials, originalSubs, originalOther])

        useEffect(() => {
            const cL = pNum(currentLabor?.floatValue)
            const cE = pNum(currentEquipment?.floatValue)
            const cM = pNum(currentMaterials?.floatValue)
            const cS = pNum(currentSubs?.floatValue)
            const cO = pNum(currentOther?.floatValue)
            setCurrentAmount(fNum(cL + cE + cM + cS + cO))
        }, [currentLabor, currentEquipment, currentMaterials, currentSubs, currentOther])

        const statusOptions = [
            { label: '3rd Party Price Volatility', value: '3rd Party Price Volatility' },
            { label: 'Weather', value: 'Weather' },
            { label: 'Warranty / Duration', value: 'Warranty / Duration' },
            { label: 'Terrain', value: 'Terrain' },
            { label: 'Sub Surface Conditions', value: 'Sub Surface Conditions' },
            { label: 'Staffing', value: 'Staffing' },
            { label: 'Security Risk', value: 'Security Risk' },
            { label: 'Scope', value: 'Scope' },
            { label: 'Schedule', value: 'Schedule' },
            { label: 'Safety - HSE', value: 'Safety - HSE' },
            { label: 'Quality Risk', value: 'Quality Risk' },
            { label: 'Other Unidentified Risk', value: 'Other Unidentified Risk' },
            { label: 'Liquidated Damages', value: 'Liquidated Damages' },
            { label: 'Contract', value: 'Contract' },
            { label: 'Client', value: 'Client' }
        ]

        return (
            <View style={{ flexDirection: 'row' }}>
                {/* Item # and Status stay in view while the table scrolls sideways */}
                <View style={{ flexDirection: 'row', position: 'sticky', left: 0, zIndex: 3, backgroundColor: 'white' }}>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={item} onChangeText={(a) => { setItem(a); handleInputChange('Item', a) }} style={s(60).spanTR}></TextInput>
                </View>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={status} onChangeText={(a) => { setStatus(a); handleInputChange('Status', a) }} style={s(120).spanTR}></TextInput>
                </View>
                </View>
                <select
                    style={{
                        width: 300,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        borderStyle: 'solid',
                        padding: 8,
                        borderRadius: 4
                    }}
                    value={riskDescription}
                    onChange={(e) => {
                        setRiskDescription(e.target.value);
                        handleInputChange('Risk_Description', e.target.value)
                        setIsFocus(false);
                    }}
                >
                    <option value="">Select Status</option>
                    {statusOptions.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
                {riskExpanded ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <TextInput value={potentialImpact} onChangeText={(a) => { setPotentialImpact(a); handleInputChange('Potential_Impact', a) }} style={s(200).spanTR}></TextInput>
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <TextInput value={handlingStrategies} onChangeText={(a) => { setHandlingStrategies(a); handleInputChange('Handling_Strategies', a) }} style={s(200).spanTR}></TextInput>
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <TextInput value={actionOwner} onChangeText={(a) => { setActionOwner(a); handleInputChange('Action_Owner', a) }} style={s(200).spanTR}></TextInput>
                    </View>
                </View> : null}
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={probabilityAssessment} onChangeText={(a) => { setProbabilityAssessment(a); handleInputChange('Probability_Assessment', a) }} style={s(100).spanTR}></TextInput>
                </View>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={severity} onChangeText={(a) => { setSeverity(a); handleInputChange('Severity', a) }} style={s(100).spanTR}></TextInput>
                </View>
                <Text style={s(100).spanT}>{riskRating}</Text>
                <Text style={s(100).spanT}>{riskCategory}</Text>
                <Text style={s(100).spanT}>{originalAmount}</Text>
                {originalAmountOpen ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={originalLabor?.formattedValue}
                            onValueChange={(t) => {
                                setOriginalLabor(t)
                                handleInputChange('Original_Labor', t.floatValue)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={originalEquipment?.formattedValue}
                            onValueChange={(t) => {
                                setOriginalEquipment(t)
                                handleInputChange('Original_Equipment', t.floatValue)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={originalMaterials?.formattedValue}
                            onValueChange={(t) => {
                                setOriginalMaterials(t)
                                handleInputChange('Original_Materials', t.floatValue)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={originalSubs?.formattedValue}
                            onValueChange={(t) => {
                                setOriginalSubs(t)
                                handleInputChange('Original_Subs', t.floatValue)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={originalOther?.formattedValue}
                            onValueChange={(t) => {
                                setOriginalOther(t)
                                handleInputChange('Original_Other', t.floatValue)
                            }}
                        />
                    </View>
                </View> : null}
                <View style={{ width: 20 }}></View>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={dateIdentified} onChangeText={(a) => { setDateIdentified(a); handleInputChange('Date_Identified', a) }} style={s(100).spanTR}></TextInput>
                </View>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={dateExpected} onChangeText={(a) => { setDateExpected(a); handleInputChange('Date_Expected', a) }} style={s(100).spanTR}></TextInput>
                </View>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={dateClosed} onChangeText={(a) => { setDateClosed(a); handleInputChange('Date_Closed', a) }} style={s(100).spanTR}></TextInput>
                </View>
                <View style={{ width: 20 }}></View>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={probabilityAssessmentCurrent} onChangeText={(a) => { setProbabilityAssessmentCurrent(a); handleInputChange('Probability_Assessment_Current', a) }} style={s(100).spanTR}></TextInput>
                </View>
                <View style={{ position: 'relative' }}>
                    <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                    <TextInput value={severityCurrent} onChangeText={(a) => { setSeverityCurrent(a); handleInputChange('Severity_Current', a) }} style={s(100).spanTR}></TextInput>
                </View>
                <Text style={s(100).spanT}>{riskRatingCurrent}</Text>
                <Text style={s(100).spanT}>{riskCategoryCurrent}</Text>
                <Text style={s(100).spanT}>{currentAmount}</Text>
                {currentAmountOpen ? <View style={{ flexDirection: 'row' }}>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={currentLabor?.formattedValue}
                            onValueChange={(t) => {
                                setCurrentLabor(t)
                                handleInputChange('CurrentLabor', t.floatValue, 101101)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={currentEquipment?.formattedValue}
                            onValueChange={(t) => {
                                setCurrentEquipment(t)
                                handleInputChange('CurrentEquipment', t.floatValue, 101101)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}

                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={currentMaterials?.formattedValue}
                            onValueChange={(t) => {
                                setCurrentMaterials(t)
                                handleInputChange('CurrentMaterials', t.floatValue, 101101)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={currentSubs?.formattedValue}
                            onValueChange={(t) => {
                                setCurrentSubs(t)
                                handleInputChange('CurrentSubs', t.floatValue, 101101)
                            }}
                        />
                    </View>
                    <View style={{ position: 'relative' }}>
                        <View style={{ width: 3, height: 28, backgroundColor: '#808080', left: 5, top: 4, position: 'absolute', zIndex: 2 }}></View>
                        <NumberInput style={s(100).spanTR}
                            thousandSeparator
                            decimalSeparator="."
                            valueIsNumericString={true}
                            value={currentOther?.formattedValue}
                            onValueChange={(t) => {
                                setCurrentOther(t)
                                handleInputChange('CurrentOther', t.floatValue, 101101)
                            }}
                        />
                    </View>
                </View> : null}
            </View>
        )
    }

    const HeaderSections = () => {
        return (
            <View style={{ flexDirection: 'row' }}>
                <Text style={s(480).spanH}></Text>
                {riskExpanded ? <View style={{ width: 600 }}></View> : null}
                <Text style={s(originalAmountOpen ? 1000 : 500).spanHR}>Original Estimate</Text>
                <View style={{ width: 20 }}></View>
                <Text style={s(300).spanHR}>Dates</Text>
                <View style={{ width: 20 }}></View>
                <Text style={s(currentAmountOpen ? 1000 : 500).spanHR}>Current Estimate</Text>

            </View>
        )
    }

    const TotalSections = () => {
        return (
            <View style={{ flexDirection: 'row' }}>
                <View style={{ width: 780 }}></View>
                {riskExpanded ? <View style={{ width: 600 }}></View> : null}
                <Text style={s(100).spanTB}>Total</Text>
                <Text style={s(100).spanTB}>{totalOriginal}</Text>
                {originalAmountOpen ? <View style={{ flexDirection: 'row' }}>
                    <Text style={s(100).spanTB}>{totalOriginalLabor}</Text>
                    <Text style={s(100).spanTB}>{totalOriginalEquipment}</Text>
                    <Text style={s(100).spanTB}>{totalOriginalMaterials}</Text>
                    <Text style={s(100).spanTB}>{totalOriginalSubs}</Text>
                    <Text style={s(100).spanTB}>{totalOriginalOther}</Text>
                </View> : null}
                <View style={{ width: 640 }}></View>
                <Text style={s(100).spanTB}>Total</Text>
                <Text style={s(100).spanTB}>{totalCurrent}</Text>
                {currentAmountOpen ? <View style={{ flexDirection: 'row' }}>
                    <Text style={s(100).spanTB}>{totalCurrentLabor}</Text>
                    <Text style={s(100).spanTB}>{totalCurrentEquipment}</Text>
                    <Text style={s(100).spanTB}>{totalCurrentMaterials}</Text>
                    <Text style={s(100).spanTB}>{totalCurrentSubs}</Text>
                    <Text style={s(100).spanTB}>{totalCurrentOther}</Text>
                </View> : null}
            </View>
        )
    }

    const HeaderRow = () => {
        return (
            <View style={{ flexDirection: 'row' }}>
                {/* Item # and Status stay in view while the table scrolls sideways */}
                <View style={{ flexDirection: 'row', position: 'sticky', left: 0, zIndex: 3, backgroundColor: 'white' }}>
                    <Text style={s(60).spanH}>Item #</Text>
                    <Text style={s(120).spanH}>Status</Text>
                </View>
                <Text style={[s(300).spanH, { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>
                    Risk Description
                    <Icon3
                        name={riskExpanded ? "MdExpandMore" : "MdChevronRight"}
                        size={20}
                        color="#1e293b"
                        onClick={() => {
                            setRiskExpanded(!riskExpanded)
                        }}
                    />
                </Text>
                {riskExpanded ? <View style={{ flexDirection: 'row' }}><Text style={s(200).spanH}>Potential Impact</Text>
                    <Text style={s(200).spanH}>Handling Strategies (Detailed)</Text>
                    <Text style={s(200).spanH}>Action Owner</Text></View> : null}
                <Text style={s(100).spanHR}>Probability Assessment</Text>
                <Text style={s(100).spanHR}>Severity</Text>
                <Text style={s(100).spanHR}>Risk Rating</Text>
                <Text style={s(100).spanHR}>Risk Category</Text>
                <Text style={[s(100).spanHR, { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>Original Amount
                    <Icon3
                        name={originalAmountOpen ? "MdExpandMore" : "MdChevronRight"}
                        size={20}
                        color="#1e293b"
                        onClick={() => {
                            setOriginalAmountOpen(!originalAmountOpen)
                        }}
                    />
                </Text>
                {originalAmountOpen ? <View style={{ flexDirection: 'row' }}>
                    <Text style={s(100).spanHR}>Labor</Text>
                    <Text style={s(100).spanHR}>Equipment</Text>
                    <Text style={s(100).spanHR}>Materials</Text>
                    <Text style={s(100).spanHR}>Subs</Text>
                    <Text style={s(100).spanHR}>Other</Text>
                </View> : null}
                <View style={{ width: 20 }}></View>
                <Text style={s(100).spanHR}>Date Identified</Text>
                <Text style={s(100).spanHR}>Date Expected</Text>
                <Text style={s(100).spanHR}>Date Closed</Text>
                <View style={{ width: 20 }}></View>
                <Text style={s(100).spanHR}>Probability Assessment</Text>
                <Text style={s(100).spanHR}>Severity</Text>
                <Text style={s(100).spanHR}>Risk Rating</Text>
                <Text style={s(100).spanHR}>Risk Category</Text>
                <Text style={[s(100).spanHR, { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }]}>Current Amount
                    <Icon3
                        name={currentAmountOpen ? "MdExpandMore" : "MdChevronRight"}
                        size={20}
                        color="#1e293b"
                        onClick={() => {
                            setCurrentAmountOpen(!currentAmountOpen)
                        }}
                    />
                </Text>
                {currentAmountOpen ? <View style={{ flexDirection: 'row' }}>
                    <Text style={s(100).spanHR}>Labor</Text>
                    <Text style={s(100).spanHR}>Equipment</Text>
                    <Text style={s(100).spanHR}>Materials</Text>
                    <Text style={s(100).spanHR}>Subs</Text>
                    <Text style={s(100).spanHR}>Other</Text>
                </View> : null}
            </View>
        )
    }

    return (
        <View style={{ margin: 30 }}>
                {/* The table, the rating chart and the guidelines sit side by side on a
                    wide screen and wrap onto their own rows on a narrower one */}
                <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                    {/* The table's card is as wide as the table; the page scrolls sideways */}
                    <View style={{ width: 'max-content' }}>
                        <View style={{
                            backgroundColor: 'white',
                            borderRadius: 8,
                            padding: 24,
                            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                            border: '1px solid #e2e8f0'
                        }}>
                            {/* As wide as the widest row, so no cell shrinks and the header and data rows agree */}
                            <View style={{ width: 'max-content', minWidth: '100%' }}>
                            <HeaderSections />
                            <HeaderRow />
                            {contingencyRows.map((row, index) => (
                                <Row key={index} id={row.id} data={row} index={index} />
                            ))}
                            <Row />
                            <TotalSections />
                            </View>
                        </View>
                    </View>
                    <View style={{ flexDirection: 'row' }}>
                        <View style={{ 
                            margin: 20, 
                            marginTop: 0, 
                            backgroundColor: 'white', 
                            borderRadius: 8, 
                            padding: 24, 
                            width: 600,
                            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                            border: '1px solid #e2e8f0'
                        }}>
                            <Text style={{ textAlign: 'center', fontSize: 16, fontWeight: '600', color: '#1e293b', marginBottom: 16 }}>Risk Rating Chart</Text>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ width: 100, textAlign: 'left' }}>Severity / Probability</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>1</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>2</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>3</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>4</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>5</Text>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 }}>
                                <Text style={{ width: 100, textAlign: 'left' }}></Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>Negligible</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>Marginal</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>Moderate</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>Major</Text>
                                <Text style={{ width: 100, textAlign: 'center' }}>Catastrophic</Text>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ width: 100, textAlign: 'left' }}>1 Not Likely</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'lightgreen' }}>1</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'lightgreen' }}>2</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'lightgreen' }}>3</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>4</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>5</Text>

                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ width: 100, textAlign: 'left' }}>2 Possible</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'lightgreen' }}>2</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'lightgreen' }}>4</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>6</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>8</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>10</Text>

                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ width: 100, textAlign: 'left' }}>3 Likely</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'lightgreen' }}>3</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>6</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>9</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>12</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>15</Text>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ width: 100, textAlign: 'left' }}>4 Probable</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'lightgreen' }}>4</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>8</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>12</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>16</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>20</Text>
                            </View>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Text style={{ width: 100, textAlign: 'left' }}>5 Eminent</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>5</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'yellow' }}>10</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>15</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>20</Text>
                                <Text style={{ width: 100, textAlign: 'center', backgroundColor: 'red' }}>25</Text>
                            </View>
                        </View>
                        {/* <View style={{ margin: 20, backgroundColor: 'white', borderRadius: 5, padding: 20, width: 600 }}>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Text style={{ width: 100, textAlign: 'left' }}>Job Week</Text>
                            <Text style={{ width: 100, textAlign: 'left' }}>Week (starting Monday)</Text>
                            <Text style={{ width: 100, textAlign: 'left' }}>Act Cost by Date (Inv/FT/etc)</Text>
                            <Text style={{ width: 100, textAlign: 'left' }}>Act Total Cost</Text>
                            <Text style={{ width: 100, textAlign: 'left' }}>Contingency</Text>
                        </View>
                    </View> */}
                    </View>
                    <View style={{ minWidth: 0, maxWidth: '100%' }}>
                        <View style={{
                            backgroundColor: 'white',
                            borderRadius: 8,
                            padding: 24,
                            width: 800, maxWidth: '100%',
                            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                            border: '1px solid #e2e8f0'
                        }}>
                            <Text style={{ textAlign: 'center', fontSize: 16, fontWeight: '600', color: '#1e293b', marginBottom: 16 }}>Severity Assessment Guidelines</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>1. Negligible:</Text> Safety, cost, schedule and reputation impact would be less than 1% of the total project cost. Scope impact or quality issues would barely be noticeable.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>2. Marginal:</Text> Safety, cost, schedule and reputation impact would be less than 5% of the total project cost. Scope would be affected in only minor areas or the quality impact would be noticeable in only the most demanding applications.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>3. Moderate:</Text> Safety, cost, and/or schedule impacts would be in the 5% to 10% range of the total project cost. Major areas of scope would be affected or quality reductions would require Owner/Client approval.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>4. Major:</Text> Safety, cost, and/or schedule impacts would be in the 10% to 20% range of the total project cost. Scope impacts would be unacceptable to the Owner/Client or quality impacts would be unacceptable to the Owner/Client.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>5. Catastrophic:</Text> Safety, cost, and/or schedule impacts would be greater than 20% of the total project cost, or the project deliverable is effectively useless or unusable.</Text>
                        </View>
                        <View style={{ 
                            margin: 20, 
                            marginLeft: 0,
                            backgroundColor: 'white',
                            borderRadius: 8,
                            padding: 24,
                            width: 800, maxWidth: '100%',
                            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                            border: '1px solid #e2e8f0'
                        }}>
                            <Text style={{ textAlign: 'center', fontSize: 16, fontWeight: '600', color: '#1e293b', marginBottom: 16 }}>Probability Assessment Guidelines</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>1. Not Likely:</Text> The risk/opportunity event is very unlikely to occur in the life of the project. Chance of occurrence &lt;10%.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>2. Possible:</Text> The risk/opportunity event might occur during the project.  Chance of occurrence &gt;10%, &lt;40%.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>3. Likely:</Text> The risk/opportunity event could occur once during the project.  Chance of occurrence &gt;40%, &lt;60%.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>4. Probable:</Text> The risk/opportunity event is likely to occur at least once during the project.  Chance of occurrence &gt;60%, &lt;90%.</Text>
                            <Text style={{ fontSize: 14, borderBottom: 1, borderColor: '#e2e8f0', paddingVertical: 8, color: '#475569' }}><Text style={{ fontWeight: 600, color: '#1e293b' }}>5. Eminent:</Text> The risk/opportunity event is very likely to occur at least once and probably will occur multiple times.  Chance of occurrence &lt;90%.</Text>
                        </View>
                    </View>
                </View>
            </View>

    );
};

export default Contingency;


